export const options = [
  { value: "JavaScript", label: "JavaScript" },
  { value: "HTML/CSS", label: "HTML/CSS" },
  { value: "SQL",label: "SQL" },
  { value: "Python", label: "Python" },
  { value: "Java", label: "Java" },
  { value: "C#", label: "C#" },
  { value: "PHP", label: "PHP" },
  { value: "C++",label: "C++" },
  { value: "TypeScript", label: "TypeScript" },
  { value: "React", label: "React" },
  { value: "React Native", label: "React Native" },
  { value: "Node.js", label: "Node.js" },
  { value: ".NET", label: ".NET" },
  { value: ".NET Core", label: ".NET Core" },
  { value: "Pandas",label: "Pandas" },
  { value: "Unity 3D", label: "Unity 3D" },
  { value: "C", label: "C" },
  { value: "Ruby", label: "Ruby" },
  { value: "GO", label: "GO" },
  { value: "Swift",label: "Swift" },
  { value: "Kotlin", label: "Kotlin" },
  { value: "Objective-C", label: "Objective-C" },
  { value: "Scala", label: "Scala" },
  { value: "Rust", label: "Rust" },
  { value: "Dart",label: "Dart" },
  { value: "Elixir", label: "Elixir" },
  { value: "Other", label: "Other" },
];